import React from 'react';
import KnowledgeBaseDetailSection from '../../../sections/AdminDashboard/Support/KnowledgeBaseDetail';

const KnowledgeBaseDetail = () => {
  return <KnowledgeBaseDetailSection />;
};

export default KnowledgeBaseDetail;
